import { useState, useMemo, useEffect } from 'react';
import { Button } from '../ui/button';

export const PAGE_SIZES = [10, 20, 50, 100];

export function usePagedList(items) {
  const list = items || [];
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(1);
  const total = list.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => {
    setPage(p => (p > totalPages ? totalPages : p));
  }, [totalPages]);

  const current = Math.min(page, totalPages);
  const start = (current - 1) * pageSize;
  const paged = useMemo(() => list.slice(start, start + pageSize), [list, start, pageSize]);

  return { paged, page: current, setPage, pageSize, setPageSize, total, totalPages, start };
}

export const ListPager = ({ pager, testId = 'list' }) => {
  const { page, setPage, pageSize, setPageSize, total, totalPages, start } = pager;
  if (total === 0) return null;
  return (
    <div
      className="flex flex-wrap items-center justify-between gap-3 px-1 py-3"
      data-testid={`${testId}-pager`}
    >
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">表示件数</span>
        <select
          value={pageSize}
          onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
          className="border rounded px-2 py-1 text-sm bg-white"
          data-testid={`${testId}-page-size`}
        >
          {PAGE_SIZES.map(n => <option key={n} value={n}>{n}件</option>)}
        </select>
        <span className="text-sm text-gray-500" data-testid={`${testId}-range`}>
          {start + 1}〜{Math.min(start + pageSize, total)} / 全{total}件
        </span>
      </div>
      {totalPages > 1 && (
        <div className="flex items-center gap-1">
          <Button size="sm" variant="outline" disabled={page <= 1}
            onClick={() => setPage(page - 1)} data-testid={`${testId}-prev`}>前へ</Button>
          <span className="text-sm text-gray-600 px-2" data-testid={`${testId}-page-label`}>{page} / {totalPages}</span>
          <Button size="sm" variant="outline" disabled={page >= totalPages}
            onClick={() => setPage(page + 1)} data-testid={`${testId}-next`}>次へ</Button>
        </div>
      )}
    </div>
  );
};

export default ListPager;
